import axios from "../../../common/utils/axios";
import store from "../../../store";
import { UPDATE_LATEST_KITS ,UPDATE_LATESTSOLD_KITS } from "./actions";

export default {
  state: {
    latestkits: [],
    latestSoldkits:[]
  },
  getters: {
    latestkits: state => state.latestkits,
    latestSoldkits: state => state.latestSoldkits,

  },
  mutations: {
    [UPDATE_LATEST_KITS]: (state, latestKits) => {
      state.latestkits = latestKits;
    },
    [UPDATE_LATESTSOLD_KITS]: (state, latestSoldkits) => {
      state.latestSoldkits = latestSoldkits;
    }
  },
  actions: {
    [UPDATE_LATEST_KITS]: async ({ commit }, data) => {
      commit(UPDATE_LATEST_KITS, data)
    },
    [UPDATE_LATESTSOLD_KITS]: async ({ commit }, data) => {
      commit(UPDATE_LATESTSOLD_KITS, data)
    },
  },
};
